import { render, staticRenderFns } from "./PrintHead.vue?vue&type=template&id=503a35a6&scoped=true&"
import script from "./PrintHead.vue?vue&type=script&lang=ts&"
export * from "./PrintHead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503a35a6",
  null
  
)

export default component.exports